import { storableError } from '../../../../util/errors';
import * as log from '../../../../util/log';
import { fetchPendingEdits, approveEdit, rejectEdit } from '../../api';

// ================ Action types ================ //

export const FETCH_PENDING_EDITS_REQUEST = 'app/EditApprovalDashboard/FETCH_PENDING_EDITS_REQUEST';
export const FETCH_PENDING_EDITS_SUCCESS = 'app/EditApprovalDashboard/FETCH_PENDING_EDITS_SUCCESS';
export const FETCH_PENDING_EDITS_ERROR = 'app/EditApprovalDashboard/FETCH_PENDING_EDITS_ERROR';

export const APPROVE_EDIT_REQUEST = 'app/EditApprovalDashboard/APPROVE_EDIT_REQUEST';
export const APPROVE_EDIT_SUCCESS = 'app/EditApprovalDashboard/APPROVE_EDIT_SUCCESS';
export const APPROVE_EDIT_ERROR = 'app/EditApprovalDashboard/APPROVE_EDIT_ERROR';

export const REJECT_EDIT_REQUEST = 'app/EditApprovalDashboard/REJECT_EDIT_REQUEST';
export const REJECT_EDIT_SUCCESS = 'app/EditApprovalDashboard/REJECT_EDIT_SUCCESS';
export const REJECT_EDIT_ERROR = 'app/EditApprovalDashboard/REJECT_EDIT_ERROR';

// ================ Reducer ================ //

const initialState = {
  pendingEdits: [],
  fetchInProgress: false,
  fetchError: null,
  approveInProgress: false,
  approveError: null,
  rejectInProgress: false,
  rejectError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_PENDING_EDITS_REQUEST:
      return { ...state, fetchInProgress: true, fetchError: null };
    case FETCH_PENDING_EDITS_SUCCESS:
      return { ...state, pendingEdits: payload, fetchInProgress: false };
    case FETCH_PENDING_EDITS_ERROR:
      return { ...state, pendingEdits: [], fetchInProgress: false, fetchError: payload };

    case APPROVE_EDIT_REQUEST:
      return { ...state, approveInProgress: true, approveError: null };
    case APPROVE_EDIT_SUCCESS:
      // Remove approved listing from pending list
      return {
        ...state,
        pendingEdits: state.pendingEdits.filter(item => item.id.uuid !== payload),
        approveInProgress: false,
      };
    case APPROVE_EDIT_ERROR:
      return { ...state, approveInProgress: false, approveError: payload };

    case REJECT_EDIT_REQUEST:
      return { ...state, rejectInProgress: true, rejectError: null };
    case REJECT_EDIT_SUCCESS:
      // Remove rejected listing from pending list
      return {
        ...state,
        pendingEdits: state.pendingEdits.filter(item => item.id.uuid !== payload),
        rejectInProgress: false,
      };
    case REJECT_EDIT_ERROR:
      return { ...state, rejectInProgress: false, rejectError: payload };

    default:
      return state;
  }
}

// ================ Action creators ================ //

const fetchPendingEditsRequest = () => ({ type: FETCH_PENDING_EDITS_REQUEST });
const fetchPendingEditsSuccess = pendingEdits => ({
  type: FETCH_PENDING_EDITS_SUCCESS,
  payload: pendingEdits,
});
const fetchPendingEditsError = error => ({
  type: FETCH_PENDING_EDITS_ERROR,
  payload: error,
});

const approveEditRequest = () => ({ type: APPROVE_EDIT_REQUEST });
const approveEditSuccess = listingId => ({
  type: APPROVE_EDIT_SUCCESS,
  payload: listingId,
});
const approveEditError = error => ({
  type: APPROVE_EDIT_ERROR,
  payload: error,
});

const rejectEditRequest = () => ({ type: REJECT_EDIT_REQUEST });
const rejectEditSuccess = listingId => ({
  type: REJECT_EDIT_SUCCESS,
  payload: listingId,
});
const rejectEditError = error => ({
  type: REJECT_EDIT_ERROR,
  payload: error,
});

// ================ Thunks ================ //

export const loadPendingEdits = () => (dispatch, getState, sdk) => {
  dispatch(fetchPendingEditsRequest());

  return fetchPendingEdits()
    .then(response => {
      dispatch(fetchPendingEditsSuccess(response.data || []));
      return response;
    })
    .catch(e => {
      log.error(e, 'fetch-pending-edits-failed');
      dispatch(fetchPendingEditsError(storableError(e)));
    });
};

export const handleApproveEdit = (listingId, adminComment) => (dispatch, getState, sdk) => {
  dispatch(approveEditRequest());

  return approveEdit(listingId, adminComment)
    .then(response => {
      dispatch(approveEditSuccess(listingId));
      // Reload pending edits
      dispatch(loadPendingEdits());
      return response;
    })
    .catch(e => {
      log.error(e, 'approve-edit-failed', { listingId });
      dispatch(approveEditError(storableError(e)));
    });
};

export const handleRejectEdit = (listingId, rejectionReason) => (dispatch, getState, sdk) => {
  dispatch(rejectEditRequest());

  return rejectEdit(listingId, rejectionReason)
    .then(response => {
      dispatch(rejectEditSuccess(listingId));
      // Reload pending edits
      dispatch(loadPendingEdits());
      return response;
    })
    .catch(e => {
      log.error(e, 'reject-edit-failed', { listingId });
      dispatch(rejectEditError(storableError(e)));
    });
};
